import React from 'react';
import { APITypes } from '../../../../../primary-record-types';
import { TempAndPersistedAvatarState } from '../../../../v2BaseComponents/ImagePicker/TempImagePicker';

export type Step = 'step1' | 'step2';

export type ContactDetailsFormValue = APITypes.medicalProfileService.MedicalProfileContactDetails & {
    avatar: TempAndPersistedAvatarState | null;
};

export type EditContactDetailsContextType = {
    medicalProfileId: string;
    contactDetails: ContactDetailsFormValue;
    onContactDetailsChange: (contactDetails: ContactDetailsFormValue) => void;
    onComplete: (contactDetails: ContactDetailsFormValue) => void;
    isUpdating: boolean;
    setStep: (step: Step) => void;
};

export const EditContactDetailsContext = React.createContext<EditContactDetailsContextType>({
    medicalProfileId: '',
    contactDetails: {} as any,
    onContactDetailsChange: () => {},
    onComplete: () => {},
    isUpdating: false,
    setStep: () => {},
});
